export const PAYMENT_BILL_TYPE = { MANUAL: 'MANUAL', MANUAL_USER: 'MANUAL-USER' };

export const BILL_PAYMENT = 'BillPayment';
export const HHPAY = 'HHPAY';

export const BILLS_CALLER_MODULE = 'bills';

export const TAB_QUERY_KEY = 'tab';
export const BILLS_HISTORY = {
  TAB_KEY: 'history',
  LABEL: 'History',
};
export const BILLS_CURRENT = {
  TAB_KEY: 'current',
  LABEL: 'Current',
};

// DocText
export const PAYMENT_2C2P_ERROR_LIST = 'PaymentService.2c2pErrorList';
export const PAYMENT_SERVICE_RECEIPT_SUCCESS = 'PaymentService.Receipt.Success';
